import Vue from 'vue';
import Vuex from 'vuex';
import {
    applyAuthorizationHeader,
    clearAccessToken,
    clearStoredUser,
    getAccessToken,
    getStoredUser,
    setAccessToken,
    setStoredUser
} from '../utils/auth';

Vue.use(Vuex);

var DEFAULT_APP_NAME = '今兔执照注销管理系统';

export default new Vuex.Store({
    state: {
        appName: DEFAULT_APP_NAME,
        siteLogoUrl: '',
        accessToken: getAccessToken(),
        currentUser: getStoredUser()
    },
    mutations: {
        setAppName(state, value) {
            state.appName = value;
        },
        setSiteLogoUrl(state, value) {
            state.siteLogoUrl = value || '';
        },
        setAccessToken(state, token) {
            state.accessToken = token || '';
        },
        setCurrentUser(state, user) {
            state.currentUser = user || null;
        }
    },
    actions: {
        login(context, payload) {
            return window.axios.post('/auth/login', payload).then(function (response) {
                var data = response.data || {};
                var token = data.access_token || '';
                var user = data.user || null;

                setAccessToken(token);
                setStoredUser(user);
                applyAuthorizationHeader(token);

                context.commit('setAccessToken', token);
                context.commit('setCurrentUser', user);

                return context.dispatch('fetchBranding').then(function () {
                    return response;
                });
            });
        },
        fetchBranding(context) {
            if (!context.state.accessToken) {
                context.commit('setSiteLogoUrl', '');
                return Promise.resolve(null);
            }

            applyAuthorizationHeader(context.state.accessToken);

            return window.axios.get('/branding').then(function (response) {
                var data = response.data.data || {};

                context.commit('setSiteLogoUrl', data.logo_url || '');

                if (data.site_name) {
                    context.commit('setAppName', data.site_name);
                } else {
                    context.commit('setAppName', DEFAULT_APP_NAME);
                }

                return data;
            }).catch(function () {
                return null;
            });
        },
        fetchCurrentUser(context) {
            if (!context.state.accessToken) {
                return Promise.resolve(null);
            }

            applyAuthorizationHeader(context.state.accessToken);

            return window.axios.get('/auth/me').then(function (response) {
                var user = response.data.data || null;
                setStoredUser(user);
                context.commit('setCurrentUser', user);
                return user;
            }).catch(function (error) {
                if (error.response && error.response.status === 401) {
                    clearAccessToken();
                    clearStoredUser();
                    applyAuthorizationHeader('');
                    context.commit('setAccessToken', '');
                    context.commit('setCurrentUser', null);
                    window.location.href = '/#/login';
                }
                return Promise.reject(error);
            });
        },
        logout(context) {
            var request = Promise.resolve();

            if (context.state.accessToken) {
                request = window.axios.post('/auth/logout');
            }

            return request.finally(function () {
                clearAccessToken();
                clearStoredUser();
                applyAuthorizationHeader('');
                context.commit('setAccessToken', '');
                context.commit('setCurrentUser', null);
                context.commit('setSiteLogoUrl', '');
                context.commit('setAppName', DEFAULT_APP_NAME);
            });
        }
    },
    getters: {
        appName: function (state) {
            return state.appName;
        },
        siteLogoUrl: function (state) {
            return state.siteLogoUrl;
        },
        accessToken: function (state) {
            return state.accessToken;
        },
        currentUser: function (state) {
            return state.currentUser;
        },
        isAuthenticated: function (state) {
            return !!state.accessToken;
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js